import {Link} from 'react-router-dom'
import {KTSVG} from '../../../_metronic/helpers'
import React, {FC} from 'react'
import {NavLinksHeaderInterface} from '../types'

const NavLinksHeader: FC<NavLinksHeaderInterface> = ({navLinks, pathname}) => {

  return (
    <div className="d-flex overflow-auto h-45px mb-10">
      <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap">
        {navLinks.map(({path, label, iconPath, iconClass}) => (
          <li key={path} className="nav-item">
            <Link
              className={`nav-link text-active-primary me-6 ${pathname === path ? 'active' : ''}`}
              to={path}
            >
              <div className="d-flex justify-content-center align-items-center">
                {iconPath && (
                  <span className="menu-icon">
                    <KTSVG path={iconPath} className={iconClass} />
                  </span>
                )}
                <span className="d-flex justify-content-center align-items-center mx-1">
                  {label}
                </span>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export {NavLinksHeader}